import React from 'react';
import { useGameStore } from '../store/gameStore';

const TypingInput = () => {
  const { typedAnswer, setTypedAnswer, typedFeedback, checkAnswer } = useGameStore();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      checkAnswer();
    }
    // Prevent global arrow-key nav from firing while typing
    e.stopPropagation();
  };

  const borderColor =
    typedFeedback === 'correct' ? '#22c55e' :
    typedFeedback === 'wrong' ? '#ef4444' :
    '#334155';

  const background =
    typedFeedback === 'correct' ? '#052e16' :
    typedFeedback === 'wrong' ? '#2e0505' :
    '#1e293b';

  const inputStyle = {
    width: '100%',
    padding: '14px 18px',
    background,
    border: `2px solid ${borderColor}`,
    borderRadius: '12px',
    color: '#e2e8f0',
    fontSize: '1.4rem',
    fontFamily: 'inherit',
    textAlign: 'center',
    transition: 'border-color 0.2s, background 0.2s',
    boxSizing: 'border-box',
    animation: typedFeedback === 'wrong' ? 'shake 0.4s ease' : 'none',
  };

  return (
    <div>
      <div className="section-label">Or type the answer in Chinese</div>
      <input
        type="text"
        value={typedAnswer}
        onChange={(e) => setTypedAnswer(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="输入中文..."
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        style={inputStyle}
      />
    </div>
  );
};

export default TypingInput;
